import { useEffect, useMemo } from 'react'
import { usePartnerId } from '../routing/params.hooks'
import { errors } from '../error-handling/errors'
import { useCheckLaunchOnboardingProgressByPartnerQuery } from '../../__codegen__/api'

const LAUNCHED_WORKFLOW_STATE = 'launched'

export const useCheckLaunchOnboardingProgress = (skip?: boolean) => {
  const partnerId = usePartnerId({ throwOnMissing: false })
  const { data, loading, error } = useCheckLaunchOnboardingProgressByPartnerQuery({
    variables: { partnerId },
    skip: skip || !partnerId,
  })

  useEffect(() => {
    if (error) {
      errors.captureMessage(
        'useCheckLaunchOnboardingProgressByPartnerQuery call returned an error',
        {
          level: 'error',
        }
      )
    }
  }, [error])

  // Derive all values from query data during render — no useState/useEffect needed.
  // This eliminates 1-2 unnecessary re-render cycles that were caused by
  // copying query data into state via effects.
  return useMemo(() => {
    const workflowState =
      data?.onboardingServiceCheckLaunchOnboardingProgressByPartner?.workflowState ?? ''
    const hasLaunchOnboarding = !!workflowState
    const hasInProgressLaunchOnboarding =
      hasLaunchOnboarding && workflowState !== LAUNCHED_WORKFLOW_STATE

    return {
      loading,
      hasInProgressLaunchOnboarding,
      hasLaunchOnboarding,
      workflowState,
      error,
    }
  }, [data, loading, error])
}
